import React, { Component } from 'react';
import $ from 'jquery'
class Footer extends Component {


    /*componentDidMount() {
        $('#loaderlayer').remove();
        
      }*/

    render() {
      return (
        <footer>
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <span className="copyright">Copyright © Nat Studio 2018</span>
            </div>
            <div className="col-md-4">
                <a href="tel:3926546474"><i class="fa fa-phone"></i><br></br>3926546474</a>
            </div>
            <div className="col-md-4">
            </div>
          </div>
        </div>
        </footer>
        
      );
    }
  };
  export default Footer